import { BasicModel } from './basic.model';
import { City } from './city.model';

export class Address extends BasicModel<Address> {
    department: string;
    floor: string;
    number: string;
    streetName: string;
}

export class Location extends BasicModel<Location> {
    address: Address;
    city: City;

    constructor(data?: Partial<Location>) {
        super({ address: new Address(), city: new City(), ...data });
    }
}
